import { Link } from "react-router-dom";
import { ArrowRight, Download, Smartphone } from "lucide-react";
import { OFFRES_LIST } from "../offres";
import { PRESENTATION } from "../components/offres/GalerieVideos";
import { ShareWhatsApp } from "../components/ShareWhatsApp";

const DUREES = { presentation: "45 s", "cabinet-medical": "30 s", "clinique-privee-essentiel": "48 s", "maternite-gynecologie": "38 s", "laboratoire-analyses": "47 s", "hopital-district": "50 s", "clinique-privee-pro": "56 s", "chr-chu": "52 s" };

function CarteVideo({ o }) {
  return (
    <article data-testid={`wa-video-${o.slug}`} className="flex flex-col overflow-hidden rounded-2xl border border-[#7DC4E8] bg-white shadow-sm">
      <video controls preload="metadata" playsInline src={o.videoCourte} poster={o.videoCourte.replace(".mp4", ".jpg")} data-testid={`wa-player-${o.slug}`} className="aspect-[9/16] w-full bg-[#0C4A6E] object-cover" />
      <div className="flex flex-1 flex-col gap-3 p-4">
        <div>
          <p className="font-semibold text-[#0C4A6E]">{o.slug === "presentation" ? "Patient Vitalis Care" : `Vitalis ${o.nom}`}</p>
          <p className="text-xs text-slate-500" data-testid={`wa-duree-${o.slug}`}>Version courte · {DUREES[o.slug] || "1 min"}</p>
        </div>
        <ShareWhatsApp video={o.videoCourte} titre={o.slug === "presentation" ? "Patient Vitalis Care" : `Vitalis ${o.nom}`} fichier={false} testid={`wa-share-${o.slug}`} />
        <div className="mt-auto flex flex-wrap gap-x-4 gap-y-1 text-xs font-semibold text-[#0369A1]">
          <a href={o.videoCourte} download data-testid={`wa-download-${o.slug}`} className="inline-flex items-center gap-1 hover:underline"><Download size={13} /> Télécharger</a>
          <Link to={o.lien || `/offres/${o.slug}`} data-testid={`wa-offre-${o.slug}`} className="inline-flex items-center gap-1 hover:underline">Voir l'offre <ArrowRight size={13} /></Link>
        </div>
      </div>
    </article>
  );
}

export default function VideosWhatsApp() {
  const items = [PRESENTATION, ...OFFRES_LIST.filter((o) => o.videoCourte)];
  return (
    <div data-testid="videos-whatsapp-page">
      <section className="bg-[#E0F2FE]">
        <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
          <p className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-[#0369A1]"><Smartphone size={14} /> Format vertical</p>
          <h1 className="mt-3 font-display text-4xl font-bold tracking-tight text-[#0C4A6E] sm:text-5xl">Vidéos à partager sur WhatsApp</h1>
          <p className="mt-4 max-w-2xl text-base text-slate-700 md:text-lg">Les versions courtes commentées par Dr ANON Barthélémy. Un seul geste pour les envoyer à un confrère, un directeur ou un groupe.</p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5" data-testid="wa-videos-grid">
          {items.map((o) => <CarteVideo key={o.slug} o={o} />)}
        </div>
        <p className="mt-8 text-sm text-slate-500">D'autres versions courtes arrivent au fil des enregistrements. <Link to="/nos-offres" className="font-semibold text-[#0369A1] hover:underline" data-testid="wa-toutes-offres">Voir toutes les offres</Link></p>
      </section>
    </div>
  );
}
